import { t } from '@avalara/bat-apps-shared/i18n';
import FormInput from '../../../containers/shared/forms/form-input';
import PasswordInput, { strongPasswordText } from '../../shared/password-input';
import { FlexContainerRowInner } from '../../styled/skylab/page';

const CreateLoginFields = () => (
  <>
    <FlexContainerRowInner>
      <fieldset>
        <label htmlFor='first-name'>{t('client.labels.first-name')}</label>
        <FormInput fieldName='firstName' addPadding={true} />
      </fieldset>

      <fieldset>
        <label htmlFor='last-name'>{t('client.labels.last-name')}</label>
        <FormInput fieldName='lastName' addPadding={true} />
      </fieldset>
    </FlexContainerRowInner>

    <label htmlFor='email'>{t('client.labels.email-address')}</label>
    <FormInput fieldName='email' addPadding={true} />

    <label htmlFor='password'>{t('client.labels.create-a-password')}</label>
    <div id='password-description' className='input-desc pad-bottom-sm'>
      {strongPasswordText}
    </div>
    <PasswordInput marginAboveError='12px' />
  </>
);

export default CreateLoginFields;
